import defaultCopyJson from './default-copy.json';

type CopyTree = {
  [key: string]: string | CopyTree;
};

export const defaultCopy = defaultCopyJson;

export type CopyNamespace = keyof typeof defaultCopy;
export type CopyOverrides = Record<string, string>;

export type EditableCopyEntry = {
  path: string;
  label: string;
  defaultValue: string;
};

function collectEditableCopyEntries(tree: CopyTree, parentPath: string[] = []): EditableCopyEntry[] {
  return Object.entries(tree).flatMap(([key, value]) => {
    const path = [...parentPath, key];

    if (typeof value === 'string') {
      return [
        {
          path: path.join('.'),
          label: value,
          defaultValue: value
        }
      ];
    }

    return collectEditableCopyEntries(value, path);
  });
}

export const editableCopyEntries = collectEditableCopyEntries(defaultCopy);

export type EditableCopyPath = (typeof editableCopyEntries)[number]['path'];

function readDefault(path: string): string | null {
  const parts = path.split('.');
  let current: unknown = defaultCopy;

  for (const part of parts) {
    if (current == null || typeof current !== 'object' || !(part in current)) {
      return null;
    }

    current = (current as Record<string, unknown>)[part];
  }

  return typeof current === 'string' ? current : null;
}

export function getCopyValue(overrides: CopyOverrides | null | undefined, path: string, fallback?: string) {
  const override = overrides?.[path];
  if (override != null && override.trim() !== '') return override;

  return readDefault(path) ?? fallback ?? path;
}

export function splitCopyPath(path: string) {
  const [namespace, ...keyParts] = path.split('.');
  return {
    namespace,
    key: keyParts.join('.')
  };
}
